import src from "IMAGE";
export default { src, width: 1919, height: 1119, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAOklEQVR42m2NUQoAIAhDl5rd/8YpaKzo4zHGgw0ALBiBBLO6Fg6S9pHZj2xhtJR5SX3k6gUh2ZkXvgEtFwCY3TZzkAAAAABJRU5ErkJggg=="};
